import FilterFormCombined from './FilterFormCombined'

export default FilterFormCombined
